import React from 'react'
import PropTypes from 'prop-types'

import './NotifyPopup.scss'

const NotifyPopup = ({ isOpen, onClose, onLoginClick }) => {
  if (!isOpen) return null

  return (
    <div className='notify-popup-overlay' onClick={onClose}>
      <div
        className='notify-popup'
        onClick={(event) => event.stopPropagation()}
      >
        <div className='notify-popup__header'>
          <h3 className='notify-popup__title'>Account Found</h3>
          <button
            type='button'
            className='notify-popup__close'
            onClick={onClose}
            aria-label='Close'
          >
            ✕
          </button>
        </div>

        <div className='notify-popup__body'>
          <p className='notify-popup__message'>
            An account already exists with this email. Please log in to continue with your order.
          </p>

          <button
            type='button'
            className='notify-popup__login-link'
            onClick={onLoginClick}
          >
            Click here to login
          </button>
        </div>
      </div>
    </div>
  )
}

NotifyPopup.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onLoginClick: PropTypes.func,
}

export default NotifyPopup
